import AxiosInstance from "./AxiosInstance";

function filenameFromContentDisposition(
  header: string | undefined,
  fallback: string,
) {
  if (!header) return fallback;
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utf8?.[1]) {
    try {
      return decodeURIComponent(utf8[1]);
    } catch {
      return utf8[1];
    }
  }
  const quoted = /filename="([^"]+)"/i.exec(header);
  if (quoted?.[1]) return quoted[1];
  const plain = /filename=([^;]+)/i.exec(header);
  if (plain?.[1]) return plain[1].trim().replace(/^["']|["']$/g, "");
  return fallback;
}

export async function downloadBackendPdf({
  url,
  params,
  fallbackFilename,
}: {
  url: string;
  params?: Record<string, unknown>;
  fallbackFilename: string;
}) {
  const response = await AxiosInstance().get<Blob>(url, {
    params,
    responseType: "blob",
    timeout: 120000,
  });
  const data = response.data;
  if (data.type?.includes("application/json")) {
    const text = await data.text();
    let message = "Failed to download PDF";
    try {
      const parsed = JSON.parse(text);
      message = parsed?.message || parsed?.error || message;
    } catch {
      if (text) message = text;
    }
    throw new Error(message);
  }

  const header =
    (response.headers?.["content-disposition"] as string | undefined) ??
    (response.headers?.["Content-Disposition"] as string | undefined);
  const filename = filenameFromContentDisposition(header, fallbackFilename);
  const objectUrl = window.URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(objectUrl);
}
